<template>
  <div class="h-full relative overflow-auto flex flex-col overflow-x-hidden">
    <div class="sticky top-0 z-2 pageHeader" style="background-color: var(--bg-page)">
      <slot name="header">
        <div class="mobile-status-padding"></div>
        <div class="top-0 p-5 flex items-center">
          <div class="text-2xl title-color font-bold">
            <slot name="headerTitle"> - </slot>
          </div>
          <div class="ml-auto md:hidden" v-bus:EVENTS.MENU.SHOW.click>
            <ColorImg src="/images/all/menu.svg" alt="" class="bg-gray-500" />
          </div>
        </div>
      </slot>
    </div>
    <div class="w-full h-full pageBody pb-32 overflow-auto overflow-x-hidden px-4">
      <slot></slot>
    </div>
  </div>
</template>
